import React from 'react';

import actionIcon from 'images/gift/action_icon.svg';

import { ACCESS_PRO } from '@src/constants';

import styles from './styles.module.scss';

const ShowRecipientCard = ({ recipient, setEditRecipientId }) => {
  return (
    <div className={styles.subscriberContainer} key={`${recipient.id}-read`}>
      <div className={styles.nameContainer} key={`${recipient.email}-read`}>
        <div className={styles.subName}>{recipient?.name || '---'}</div>
        <div className={styles.action}>
          <img
            data-test="edit-group-subscription-button"
            id={`Edit-${recipient.recipientId}`}
            src={actionIcon}
            className="cursor-pointer"
            onClick={() => setEditRecipientId(recipient.recipientId)}
          />
        </div>
      </div>
      <div className={styles.subInfoContainer}>
        <div className={styles.subEmail}>{recipient.email}</div>
        <div className={styles.subInfo}>
          {recipient.autoRenew ? 'Auto Renew Subscription' : 'One Year Subscription'}
          {recipient.accessLevel >= ACCESS_PRO && ' - pro'}
        </div>
      </div>
    </div>
  );
};

export default ShowRecipientCard;
